import React from 'react';

/**
 * Context for tracking whether Text component is rendered inside another
 * Text component. Implemented to avoid breaking existing layout with
 * react-native-web removed.
 */
const TextAncestorContext = React.createContext(false);

export default TextAncestorContext;
